import api from "../../services/productTransaction";
export default function (helper) {
	/**
	 * Generated store module
	 */
	helper.setApi(api);
	const types = helper.types("product_transaction");
	const state = helper.state();
	const getters = helper.getters();
	const actions = helper.actions({}, "Product Transaction");
	const mutations = helper.mutations({}, types, state);

	return {
		namespaced: true,
		state,
		getters,
		actions,
		mutations,
	};
}
